/* eslint-disable */

// import ApiServiceNew from '../ApiServiceNew';
import SSOApiService from '../SSOApiService';

const AuthServices = {
  login(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/token/', data, config);
  },

  register(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('register/', data, config);
  },

  resetPassword(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/password_reset/token/', data, config);
  },

  resetPasswordConfirm(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/password_reset/confirm/', data, config);
  },

  refreshToken(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/token/refresh/', data, config);
  },

  changePassword(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('auth/password/change/', data, config);
  },

  getUserData(data, callBack) {
    SSOApiService.get('user/', data)
      .then((response) => {
        callBack({
          status: true,
          data: response.data
        })
      })
      .catch((err) => {
        console.log(err);
      });
  },

  changeDetails(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return SSOApiService.post('api/change_details/', data, config);
  },
};

export default AuthServices;
